import { render, staticRenderFns } from "./ques-steps.vue?vue&type=template&id=4d2fdada&scoped=true&"
import script from "./ques-steps.vue?vue&type=script&lang=js&"
export * from "./ques-steps.vue?vue&type=script&lang=js&"
import style0 from "./ques-steps.vue?vue&type=style&index=0&id=4d2fdada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2fdada",
  null
  
)

export default component.exports